module.exports = __webpack_public_path__ + "media/images/category_icons/music-f0f3833ca071a6e02f1abdf7ad88ba2a.svg";